// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"473":"3b53517f","499":"976aae30"}[chunkId] + ".chunk.css";
};